import { configureStore } from "@reduxjs/toolkit";
// Import feature slices here
import authReducer from "@/features/auth/store/auth.slice";
import addressReducer from "@/shared/store/address.slice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    address: addressReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
